/** @module Enums */ /** typedoc */
/**
 * This Enum allow to find a partial url for a code section in the Micro Frontend architecture using the Homepage value stored in the backend for each user.
 * The keys should always be in sync with this file https://github.com/LandrAudio/LANDR.User/blob/master/src/LANDR.User/Models/HomePageEnum.cs
 *
 * e.g:
 *  window.history.pushState({}, '', `/${AppHomePageEnum[user.homePage as keyof typeof AppHomePageEnum] || AppHomePageEnum.Mastering}`,
 *
 *  `Network` and `Samples` are other available values but they are not MFEs and they do not have support on the MFE homepage handler right now
 */
var AppHomePageEnum;
(function (AppHomePageEnum) {
    AppHomePageEnum["Dashboard"] = "dashboard";
    AppHomePageEnum["Distribution"] = "releases";
    AppHomePageEnum["Mastering"] = "library";
    AppHomePageEnum["Sessions"] = "sessions";
})(AppHomePageEnum || (AppHomePageEnum = {}));

export { AppHomePageEnum };
